import { t } from '@lingui/core/macro';
import {
  TApplication,
  TIntroducerApplication,
} from 'lendingApi/applications.types';
import { Link } from 'react-router-dom';
import { APPLICATION_STATUS } from 'utils/applications/applications.config';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { isRequestedAmount } from '../SummaryCard.helpers';
import styles from '../SummaryCard.module.css';

export const getMaxAmountLabel = (application: TIntroducerApplication) =>
  isRequestedAmount(application) ? t`Requested amount` : t`Offered amount`;

export const tooltips = (status: TApplication['status']) => ({
  available_funds: t`The additional funds that can be withdrawn.`,
  duration:
    status !== APPLICATION_STATUS.offer_rejected
      ? t`The term resets if your client takes more funds.`
      : undefined,
  max_amount: (application: TIntroducerApplication) =>
    isRequestedAmount(application)
      ? undefined
      : t`Total principal borrowed should they withdraw all available funds.`,
  initial_commission: (preferredCommissionRate: string) => (
    <>
      Percentage applies to every funding in the first 30 days from first
      funding date. Your preferred rate of commission is{' '}
      {preferredCommissionRate}. See more{' '}
      <Link
        to={PATH_NAMES.products()}
        target="blank"
        rel="noreferrer"
        className={styles.tooltipLink}
      >
        here
      </Link>
    </>
  ),
  repeat_commission:
    'Percentage applies to every funding on days 31 to 365 from first funding date.',
});
